"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenAndDismiss = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useOpenAndDismiss = function useOpenAndDismiss(onClose, onDismiss, timeout) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var close = (0, _react.useRef)(onClose);
  (0, _react.useEffect)(function () {
    close.current = onClose;
  }, [onClose]);
  var dismiss = (0, _react.useRef)(onDismiss);
  (0, _react.useEffect)(function () {
    dismiss.current = onDismiss;
  }, [onDismiss]);
  (0, _react.useEffect)(function () {
    setIsOpen(true);
  }, []);
  (0, _react.useEffect)(function () {
    var timer = setTimeout(dismissToast, timeout);
    return function () {
      clearTimeout(timer);
    };
  }, [timeout]);

  var dismissToast = function dismissToast() {
    setIsOpen(false);
    if (close.current) setTimeout(close.current, 350);
    if (dismiss.current) dismiss.current();
  };

  return [isOpen, dismissToast];
};

exports.useOpenAndDismiss = useOpenAndDismiss;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/Toasts/hooks.js
// module id = 424
// module chunks = 0